module.exports = __webpack_public_path__ + "static/media/co2_based.3c429ba0.jpg";